<template>
  <div class="flex bg-[#F1F8FE]">

    <div class="flex-1 bg-[#F1F8FE] w-full">
      <TopBar />

      <div class="p-4 md:px-8 overflow-y-auto">
        <div class="block md:flex  h-auto pt-5 gap-4 my-4">
          <!-- Second Column -->
           <div class="md:flex md:gap-x-5 md:w-[100%] w-full ">
          <div
            class="w-full bg-white h-auto border rounded-xl p-5 overflow-x-scroll md:overflow-x-hidden"
          >
            <!-- Search and Select -->
            <div class="md:flex justify-between w-full">
              <div class="py-2">
                <h1>Total Members

                  <span class="font-bold text-2xl"> ( {{ this.user_count }} )</span>
                </h1>
              </div>
              
            </div>

            <!-- Table -->
            <div class="overflow-x-auto flex gap-x-5  w-full ">
              <table class="text-left w-full border">
                <thead class="p-5 text-gray-700 font-medium w-full ">
                  <tr class="w-full">
                    <th class="p-2 text-sm">S.No</th>
                    <th class="p-2 text-sm">Name</th>
                    <th class="p-2 text-sm">Email</th>
                    <th class="p-2 text-sm">Phone no</th>
                    
                    <th class="p-2 text-sm">Date Joined</th>
                    <th class="p-2 text-sm">Status</th>
                    <th class="p-2 text-sm">Login info</th>
                  </tr>
                </thead>
                <tbody class="w-full">
                  <tr
                    class="text-left border-b  w-full py-1"
                    v-for="(user,index) in user_list"
                    :key="user"
                  >
                  <td class="p-2 text-sm">{{ index + 1 }}</td>
                    <td class="flex items-center gap-x-2 capitalize ">
                      <span
                        class="px-2 py-1 rounded-full text-xs text-white bg-[#2a84ef] h-8 w-8 flex items-center justify-center"
                        >{{ user.user_name.slice(0, 1) }}</span
                      >
                      <p class="text-sm">{{ user.user_name }}</p>
                    </td>
                    <td class="p-2 text-sm ">{{ user.user_email }}</td>
                    <td class="p-2 text-sm">{{ user.phone_number }}</td>
                    
                    <td class="p-2 text-sm">{{ new Date(user.date_joined).toLocaleString("en-GB") }}</td> 
                    <td class="p-2 text-sm capitalize">{{ user.status }}</td>
                    <td class="relative p-2" @click="loginInfo(user.user_id)">
                      <button class="px-2 py-0.5 text-sm rounded-md border">
                        View
                      </button>
                    </td>
                  </tr>
                </tbody>
                <PaginationView
                  :total_number_page="13"
                  :count_per_page="5"
                  @selectedPage="selectPageCall"
                  class="hidden"
                />
              </table>
              
            </div>
          </div>
        </div>
          
          <div
                class="w-full md:w-[40%] bg-[#FAFAFA] h-auto border rounded-xl p-5 space-y-2 max-h-[320px]"
              >
              <div
                class="flex justify-end"
              >
                
                <select
                  name="select-filter"
                  id="select-filter"
                  v-model="selected_options"
                  class="rounded-md px-2 h-8 w-full md:w-auto"
                >
                  <option value="Today">Today</option>
                  <option value="This Week">This Week</option>
                  <option value="This Month">This Month</option>
                </select>
              </div>
                <!-- New User Section -->
                <p class="py-1 flex text-start font-medium text-base">
                  New Users
                </p>
                <div class="flex flex-col text-sm">
                  <template v-if="selected_options == 'Today'">
                    <div class="flex justify-between text-sm">
                      <p class="text-semibold text-[#000000]">Login</p>
                      <p class="text-semibold text-[#000000]">{{ this.today_data.length }}</p>
                    </div>
                    <div class="flex justify-between py-1 text-sm">
                      <p class="text-gray-700">Individual</p>
                      <p class="text-gray-700">{{ this.today_joins.length }}</p>
                    </div>
                  </template>
                  <template v-else-if="selected_options == 'This Week'">
                    <div class="flex justify-between text-sm">
                      <p class="text-semibold text-[#000000]">Login</p>
                      <p class="text-semibold text-[#000000]">{{ this.this_week_data.length }}</p>
                    </div>
                    <div class="flex justify-between py-1 text-sm">
                      <p class="text-gray-700">Individual</p>
                      <p class="text-gray-700">{{ this.this_week_joins.length }}</p>
                    </div>
                  </template>
                  <template v-else-if="selected_options == 'This Month'">
                    <div class="flex justify-between text-sm">
                      <p class="text-semibold text-[#000000]">Login</p>
                      <p class="text-semibold text-[#000000]">{{ this.this_month_data.length }}</p>
                    </div>
                    <div class="flex justify-between py-1 text-sm">
                      <p class="text-gray-700">Individual</p>
                      <p class="text-gray-700">{{ this.this_month_joins.length }}</p>
                    </div>
                  </template>
                  
                  <hr class="my-5" />
                  <p class="py-1 flex text-start font-medium text-base">
                  Total Users
                  </p>
                  <div class="flex justify-between py-1">
                    <p class="text-semibold text-[#000000]">Login</p>
                    <p class="text-semibold text-[#000000]">{{ this.login_history?.count }}</p>
                  </div>
                  <div class="flex justify-between py-1">
                    <p class="text-gray-700">Individual</p>
                    <p class="text-gray-700">{{ this.user_count }}</p>
                  </div>
                  <div class="flex justify-between py-1">
                    <p class="text-gray-700">Organization</p>
                    <p class="text-gray-700 capitalize">{{ this.getUser?.organization_name }}</p>
                  </div>
                </div>
              </div>
        </div>

        
      </div>
    </div>
    <div
      v-if="is_login_info"
      class="fixed top-0 left-0 h-full w-full bg-black bg-opacity-50 flex items-center justify-center"
    >
      <div
        class="bg-white min-w-[720px] min-h-[520px] p-6 flex flex-col gap-2 relative"
      >
        <span
          class="absolute top-4 right-4 text-xl text-red-700 cursor-pointer"
          @click="is_login_info = false"
          >x</span
        >
        <h1 class="text-center text-3xl">User Login Info</h1>
        <table class="w-full text-left rounded-md">
          <thead class="p-5 text-white rounded-xl h-14">
            <tr class="bg-[#2a84ef] rounded-xl h-10 px-2">
              <th class="p-2 text-sm roboto-light font-medium rounded-md">
                Name
              </th>
              <th class="p-2 text-sm roboto-light font-medium">Source</th>
              <th class="p-2 text-sm roboto-light font-medium">
                Login date & time
              </th>
            </tr>
          </thead>
          <tbody class="w-full">
            <!--  <tr class=" text-left" v-for="(id, index) in 10" :key="id">
               <td class="p-2">{{ index + 1 }}</td> 
             {{ index + 1 }}-->
            <!-- <tr>
                <td colspan="5" class="text-center p-5">No Data Found</td>
              </tr> -->
            <template v-if="login_info.length > 0">
              <tr
                class="text-left py-2 border rounded-lg"
                v-for="(user, index) in login_info"
                :key="user"
                :class="(index + 1) % 2 == 0 ? 'bg-gray-200' : 'bg-white'"
              >
                <td class="flex p-2 items-center gap-x-2">
                  <span
                    class="px-2 py-1 rounded-full text-xs text-white bg-[#2a84ef] h-6 w-6 flex items-center justify-center"
                    >{{ user.first_name.slice(0, 1) }}
                  </span>
                  <p class="text-sm">{{ user.first_name }}</p>
                </td>
                <td class="p-2 text-sm">{{ user.login_source }}</td>
                <td class="p-2 text-sm">
                  {{ new Date(user.login_date_time).toLocaleString("en-GB") }}
                </td>
              </tr>
            </template>
            <template v-else>
              <tr class="text-center">
                <td colspan="3">No data</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/NewComponents/TopNavbar.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import PaginationView from "@/components/PaginationView.vue";

export default {
  components: {  TopBar, PaginationView },
  data() {
    return {
      login_info: [],
      user_list: [],
      user_count: 0,
      login_history: [],
      is_login_info: false,
      today_data: [],
      this_week_data: [],
      this_month_data:[],
      today_joins: [],
      this_week_joins:[],
      this_month_joins:[],
      selected_options:'Today'
    };
  },
  computed: { ...mapGetters(["getUser", "getToken"]) },
  created() {
    console.log(this.getUser, this.getToken);
    // this.loginInfo();
    this.userGetList();
    // this.postUserLoginInfo();
    this.userLoginHistory();
  },
  methods: {
    selectPageCall(val) {
      console.log(val);
    },
    userLoginHistory() {
      axios
        .get(
          `${process.env.VUE_APP_API}/organization/user-logins/distinct/?organization_id=${this.getUser.organization_id}&Key=${this.getToken}`
        )
        .then((response) => {
          if(response.status == 200) {
            this.login_history = response.data;
            this.today_data = response.data.results.filter((item) => {
              const loginDate = new Date(item.login_date_time);
              const today = new Date();
              return (
                loginDate.getDate() === today.getDate() &&
                loginDate.getMonth() === today.getMonth() &&
                loginDate.getFullYear() === today.getFullYear()
              );
            });
            this.this_week_data = response.data.results.filter((item) => {
              const loginDate = new Date(item.login_date_time);
              const today = new Date();
              const oneWeekAgo = new Date();
              oneWeekAgo.setDate(today.getDate() - 7);
              return loginDate >= oneWeekAgo && loginDate <= today;
            });
            this.this_month_data =  response.data.results.filter((item) => {
              const loginDate = new Date(item.login_date_time);
              const today = new Date();
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(today.getMonth() - 1);
              return loginDate >= oneMonthAgo && loginDate <= today;
            });
          }
        })
        .catch((er) => {
          console.log(er);
        });
    },
    userGetList() {
      axios
        .get(`${process.env.VUE_APP_API}/api/user-list/?Key=${this.getToken}`)
        .then((response) => {
          this.user_list = response.data.results;
          this.user_count = response.data.count;
          this.today_joins = this.user_list.filter((item) => {
            const joinDate = new Date(item.date_joined);
            const today = new Date();
            return (
              joinDate.getDate() === today.getDate() &&
              joinDate.getMonth() === today.getMonth() &&
              joinDate.getFullYear() === today.getFullYear()
            );
          });
          this.this_week_joins = this.user_list.filter((item) => {
            const joinDate = new Date(item.date_joined);
            const today = new Date();
            const oneWeekAgo = new Date();
            oneWeekAgo.setDate(today.getDate() - 7);
            return joinDate >= oneWeekAgo && joinDate <= today;
          });
          this.this_month_joins = this.user_list.filter((item) => {
            const joinDate = new Date(item.date_joined);
            const today = new Date();
            const oneMonthAgo = new Date();
            oneMonthAgo.setMonth(today.getMonth() - 1);
            return joinDate >= oneMonthAgo && joinDate <= today;
          });
        })
        .catch((er) => {
          console.log(er);
        });
    },
    loginInfo(id) {
      axios
        .get(
          `${process.env.VUE_APP_API}/api/login-info/${id}/?Key=${this.getToken}`
        )
        .then((response) => {
          console.log(response, "login User");
          this.login_info = response.data;
          this.is_login_info = true;
        })
        .catch((er) => {
          console.log(er);
        });
    },
  },
};
</script>
<style scoped>
table {
  overflow: hidden;
  border-radius: 15px;
}
</style>
